// authActions.js
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const loginSuccess = (token) => ({
  type: LOGIN_SUCCESS,
  payload: token,
});
